const History = window.History; // Note: We are using a capital H instead of a lower h

function getData(page) {
    const manufacturerId = $('#ManufacturerId').val();
    const modelGroupId = $('#ModelGroupId').val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const carType = $("#CarGroup").val();
    const rangeFrom = $('#RangeFrom').val();
    const rangeTo = $('#RangeTo').val();
    const priceFrom = $('#PriceFrom').val();
    const priceTo = $('#PriceTo').val();
    const sortBy = $('#Sorting').val();

    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        CarType: carType,
        RangeFrom: rangeFrom,
        RangeTo: rangeTo,
        PriceFrom: priceFrom,
        PriceTo: priceTo,
        SortBy: sortBy,
        P: page
    };
}

function handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== 'undefined') {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;

        console.log('TextDiv Height:', textDivHeight); // Debugging: Check the height

        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) {
                existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            }

            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);

            toggleBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 1.2 * 16) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });

            console.log('Toggle Button Added'); // Debugging: Confirm button is added
        }
    } else {
        console.log('TextDiv not found'); // Debugging: Check if textDiv is found
    }
}

function buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.ManufacturerName}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.ModelName}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `CarType=${data.CarType}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `RangeFrom=${data.RangeFrom}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `RangeTo=${data.RangeTo}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `PriceFrom=${data.PriceFrom}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `PriceTo=${data.PriceTo}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;

    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    return `?${queryString}`;
}

function updateResultsLogic(page) {
    const data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}
function getPage(href) {
    const querystring = href.split('?')[1];
    console.log("EV querystring: " + querystring);
    if (!querystring) {
        return null; // or some default value
    }
    const parts = querystring.split('&');
    console.log("EV parts: " + parts);
    const pageParam = $.grep(parts, function (el) {
        return el.split('=')[0] === "page";
    });
    if (!pageParam.length) {
        return null; // or some default value
    }
    return pageParam[0].split('=')[1];
}

function setManufacturer(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ManufacturerId') > 1) {
            const manId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ManufacturerId";
            })[0].split('=')[1];
            $.get(`/manufacturer-url/${manId}`, function (response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf('Manufacturer') > 1) {
            const manufacturer = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "Manufacturer";
            })[0].split('=')[1];

            $("#ManufacturerName").val(manufacturer);
        }
    }
}

function setModel(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ModelGroupId') > 1) {
            const modelId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ModelGroupId";
            })[0].split('=')[1];
            const manufacturerId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ManufacturerId";
            })[0].split('=')[1];
            $.get(`/electric-model-url/${manufacturerId}/${modelId}`, function (response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf('Model') > 1) {
            const model = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "Model";
            })[0].split('=')[1];

            $("#ModelName").val(model);
        }
    }
}

function setCarType(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('CarType') > 1) {
            const carType = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "CarType";
            })[0].split('=')[1];

            $("#CarGroup").val(carType);
        }

    }
}

function setRange(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('RangeFrom') > 1) {
            const rangeFrom = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "RangeFrom";
            })[0].split('=')[1];

            $("#RangeFrom").val(rangeFrom);
        }

        if (href.indexOf('RangeTo') > 1) {
            const rangeTo = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "RangeTo";
            })[0].split('=')[1];

            $("#RangeTo").val(rangeTo);
        }

    }
}

function setPrice(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('PriceFrom') > 1) {
            const priceFrom = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "PriceFrom";
            })[0].split('=')[1];

            $("#PriceFrom").val(priceFrom);
        }

        if (href.indexOf('PriceTo') > 1) {
            const priceTo = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "PriceTo";
            })[0].split('=')[1];

            $("#PriceTo").val(priceTo);
        }

    }
}

function markAsLoading() {
    $('#electric-vehicles-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function pageData(event) {
    event.preventDefault();
    if ($(this).attr('href') === undefined)
        return;
    const page = getPage($(this).attr('href'));
    updateResultsLogic(page);
}

function reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({ cache: false });
    $.get('/electric-vehicles/query', State.data, function (response) {
        $('#electric-vehicles-query-container').replaceWith(response);
        setupPriceSlider();
        setupRangeSlider();
        handleBodyCopyToggle();
    });

}

function onChangeFilters(event) {
    const currentDropdown = ($(this).attr("name"));
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val('');
        $("#ModelName").val('');
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$(this).val()}`, function (response) {
                $("#ManufacturerName").val(response);
                window.updateElectricVehicles();
            });
        }
        else {
            $("#ManufacturerName").val('');
            window.updateElectricVehicles();
        }
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$('#ManufacturerId').val()}`, function (response) {
                $("#ManufacturerName").val(response);
            });
            $.get(`/electric-model-url/${$('#ManufacturerId').val()}/${$(this).val()}`, function (response) {
                $("#ModelName").val(response);
                window.updateElectricVehicles();
            });
        } else {
            $("#ModelName").val('');
            window.updateElectricVehicles();
        }
    } else if (currentDropdown === "CarType") {
        $("#CarGroup").val($(this).val());
        window.updateElectricVehicles();
    } else if (currentDropdown === "SortBy") {
        $("#Sorting").val($(this).val());
        window.updateElectricVehicles();
    } else {
        window.updateElectricVehicles();
    }
}

function updateState() { // Note: We are using statechange instead of popstate#
    markAsLoading();
    reloadQuery();

    const State = History.getState();
    $.get('/electric-vehicles/results', State.data, function (response) {
        $('#electric-vehicles-results-container').replaceWith(response);
        //if (reset) {
        //    $('[data-no-results]').hide();
        //    $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose a make above to start your search</div>");
        //    reset = false;
        //}
    }).done(function () {
        setTimeout(function () {
            console.log("rendering slots for mobiles");

            // ad slots
            window.ayManagerEnv = window.ayManagerEnv || { cmd: [] };

            if (typeof Handlebars === 'undefined') {
                console.error('Handlebars not loaded.');
            }
            if (!Handlebars.helpers.json) {
                Handlebars.registerHelper('json', function (context) {
                    return JSON.stringify(context);
                });
            }
            const adSlotTemplate = Handlebars.compile(
                document.getElementById('ad-slot-template').innerHTML
            );

            const adSlots = {};
            const adSections = document.querySelectorAll('[data-ad-id]');
            if (adSections.length === 0) {
                console.warn('No ad section found.');
            }

            adSections.forEach(function (section) {
                const adDataInputs = section.querySelectorAll('[data-ad-data]');
                adDataInputs.forEach(function (adSlot) {
                    let adSlotData = adSlot.getAttribute('data-ad-data');
                    try {
                        adSlotData = JSON.parse(adSlotData);
                    } catch (e) {
                        console.warn('Invalid JSON in data-ad-data:', adSlotData);
                    }
                    if (!adSlotData || !adSlotData.slotId) {
                        console.warn('Invalid ad slot data:', adSlotData);
                    }
                    const adSlotHtml = adSlotTemplate(adSlotData);
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = adSlotHtml;
                    const newSlotElem = tempDiv.firstElementChild;

                    adSlot.parentNode.replaceChild(newSlotElem, adSlot);

                    adSlots[adSlotData.slotId] = {
                        slotId: adSlotData.slotId,
                        sizeMapping: adSlotData.sizeMapping,
                        isEager: adSlotData.isEager || false,
                        outOfPage: adSlotData.outOfPage || false,
                        container: document.getElementById(adSlotData.slotId + '-container'),
                        element: document.getElementById(adSlotData.slotId)
                    };
                });

                setupAdMovement(adSlots, section);
            });
            function shouldAdd(adSlot) {
                return !!adSlot.container.closest('[data-ads-hidden-column]');
            }
            function getIndex(adSlot) {
                const hiddenColumn = adSlot.container.closest('[data-ads-hidden-column]');
                if (!hiddenColumn) return -1;
                const holders = Array.from(hiddenColumn.querySelectorAll('[data-ad-slot-name]')).map(e => e.parentNode);
                const holder = adSlot.container.parentNode;
                return holders.indexOf(holder);
            }
            function setupAdMovement(adSlots, adSection) {
                const slotsToAdd = [];
                for (let name in adSlots) {
                    if (adSlots.hasOwnProperty(name)) {
                        const slot = adSlots[name];
                        if (shouldAdd(slot)) {
                            slotsToAdd.push(slot);
                        }
                    }
                }
                if (slotsToAdd.length === 0) return;
                slotsToAdd.sort((a, b) => getIndex(a) - getIndex(b));
                for (let adSlot of slotsToAdd) {
                    const slotName = adSlot.slotId;
                    const desktopSlot = adSlot.container;
                    let mobileReplacementSlot = adSection.querySelector(`[data-ad-mobile-replace="${slotName}"]`);
                    if (!mobileReplacementSlot) {
                        mobileReplacementSlot = document.createElement('div');
                        mobileReplacementSlot.setAttribute('data-ad-mobile-replace', slotName);
                        mobileReplacementSlot.className = 'col-md-6 mb-3 text-center';
                        adSection.appendChild(mobileReplacementSlot);
                    }
                    const responsiveMovable = desktopSlot.getAttribute('data-responsive-movable');
                    mobileReplacementSlot.setAttribute('data-responsive-movable-xs', responsiveMovable);
                    mobileReplacementSlot.setAttribute('data-responsive-movable-sm', responsiveMovable);
                }
            }

            if (window.registerMovableElements && window.moveElementsToCurrentViewport) {
                window.registerMovableElements(window.jQuery || $);
                window.moveElementsToCurrentViewport(true);
            }

            window.ayManagerEnv.cmd.push(function () {
                ayManagerEnv.changePage();
            });
        }, 250);
    });
    //$.get('/electric-vehicles/heading', State.data, function (response) {
    //    $('#electric-vehicles-heading-container').replaceWith(response);
    //});
}

function setupPriceSlider() {
    let priceFromValue = parseFloat($("#PriceFrom").val());
    let minimum = 10000;
    if (!isNaN(priceFromValue) && priceFromValue !== minimum) {
        minimum = priceFromValue;
    }
    let priceToValue = parseFloat($("#PriceTo").val());
    let maximum = 250000;
    if (!isNaN(priceToValue) && priceToValue !== maximum) {
        maximum = priceToValue;
    }

    let priceSliderInput = document.querySelector('#price-slider-range');
    priceSliderInput.setAttribute('data-old-data', `${minimum},${maximum}`);

    let priceRangeSlider = new rSlider({
        target: '#price-slider-range',
        values: { min: 10000, max: 250000 },
        range: true,
        tooltip: true,
        scale: false,
        labels: false,
        step: 500,
        set: [minimum, maximum],
        onChange: function (values) {
            let oldData = priceSliderInput.getAttribute('data-old-data');
            $("#PriceFrom").val(values.split(',')[0]);
            $("#PriceTo").val(values.split(',')[1]);
            if (oldData !== values) {
                priceSliderInput.setAttribute('data-old-data', `${values}`);
                onChangeFilters();
            }
        }
    });
}

function setupRangeSlider() {
    let rangeFromValue = parseFloat($("#RangeFrom").val());
    let minimum = 0;
    if (!isNaN(rangeFromValue) && rangeFromValue !== minimum) {
        minimum = rangeFromValue;
    }
    let rangeToValue = parseFloat($("#RangeTo").val());
    let maximum = 1000;
    if (!isNaN(rangeToValue) && rangeToValue !== maximum) {
        maximum = rangeToValue;
    }

    let rangeSliderInput = document.querySelector('#range-slider-range');
    rangeSliderInput.setAttribute('data-old-data', `${minimum},${maximum}`);

    let rangeSliderRange = new rSlider({
        target: '#range-slider-range',
        values: { min: 0, max: 1000 },
        range: true,
        tooltip: true,
        scale: false,
        labels: false,
        step: 10,
        set: [minimum, maximum],
        onChange: function (values) {
            let oldData = rangeSliderInput.getAttribute('data-old-data');
            $("#RangeFrom").val(values.split(',')[0]);
            $("#RangeTo").val(values.split(',')[1]);
            if (oldData !== values) {
                rangeSliderInput.setAttribute('data-old-data', `${values}`);
                onChangeFilters();
            }
        }
    });
}

export function setupElectricVehicles() {
    if (!$('[data-electric-vehicles]').length) {
        return;
    } 
    setManufacturer(window.location.href);
    setModel(window.location.href);
    setRange(window.location.href);
    setPrice(window.location.href);
    setCarType(window.location.href);
    $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose a make above to start your search</div>");
    $('[data-no-results]').hide();

    //dropdown changes
    $(document).on('change', '[data-electric-vehicles] input, [data-electric-vehicles] select', onChangeFilters);

    $(document).on('keypress', '[data-electric-vehicles] input', function (e) {
        if (e.keyCode === 13) {
            onChangeFilters();
            return false;
        }
    });

    //paging click
    $(document).on('click', '#electric-vehicles-results-container .pagination a', pageData);

    window.updateElectricVehicles = function () {
        updateResultsLogic(1);
    }

    // Bind to StateChange Event
    History.Adapter.bind(window, 'statechange', updateState);

    setupPriceSlider();
    setupRangeSlider();
}